import React from "react";
import tw, { css } from "twin.macro";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";
import onetwothree from "../../images/onetwothree.svg";
import processpoints from "../../images/processpoints.svg";
import glintclock from "../../images/glintclock.svg";
import { Link } from "react-router-dom";

function ProcessSection() {
  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  return (
    <div tw="bg-secondary">
      <div tw="container mx-auto">
        <div tw="flex flex-col lg:items-start items-center lg:px-36 px-14 lg:py-24 py-14">
          <motion.p
            initial="hidden"
            animate="visible"
            variants={variants}
            tw="text-white lg:text-7xl sm:text-6xl text-4xl font-extrabold"
          >
            what we
          </motion.p>
          <motion.p
            initial="hidden"
            animate="visible"
            variants={variants}
            tw="text-white lg:text-7xl sm:text-6xl text-4xl font-extrabold lg:ml-20"
          >
            are selling
          </motion.p>
          <ul tw="flex lg:flex-row text-white my-4 lg:ml-20 lg:text-base text-xs">
            <motion.li
              initial={{ x: -1500 }}
              animate={{ x: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.2,
                delay: 0.2,
              }}
              tw="flex items-center text-white mx-2"
            >
              <FaCheckCircle tw="flex-shrink-0 text-primary text-lg mr-2" />
              Quality
            </motion.li>
            <motion.li
              initial={{ x: -1500 }}
              animate={{ x: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.4,
                delay: 0.4,
              }}
              tw="flex items-center text-white mx-2"
            >
              <FaCheckCircle tw="flex-shrink-0 text-primary text-lg mr-2" />
              Reliability
            </motion.li>
            <motion.li
              initial={{ x: -1500 }}
              animate={{ x: 0 }}
              transition={{
                ease: "easeIn",
                duration: 0.6,
                delay: 0.6,
              }}
              tw="flex items-center text-white mx-2"
            >
              <FaCheckCircle tw="flex-shrink-0 text-primary text-lg mr-2" />
              Convenience
            </motion.li>
          </ul>
        </div>
      </div>
      <div tw="container mx-auto">
        <div tw="grid lg:grid-cols-2 gap-4">
          <div></div>
          <div tw="flex lg:flex-row flex-col justify-center">
            <p tw="text-primary text-2xl font-bold lg:w-1/5 lg:mt-4 text-center">
              how it works.
            </p>
            <div tw="flex lg:justify-start justify-center px-4">
              <div tw="lg:contents hidden">
                <img src={onetwothree} alt="process points" width="25px" />
              </div>

              <div tw="xl:w-3/5 lg:w-full sm:w-1/2">
                <div tw="lg:py-6 py-4 pl-4">
                  <p tw="text-white text-base font-bold">
                    Get onboarded in a jiffy.
                  </p>
                  <div tw="w-6 h-2 bg-primary"></div>
                  <p tw="text-white text-sm pt-4">
                    Chat with us on WhatsApp and get signed up instantly.
                  </p>
                </div>
                <div tw="lg:py-6 py-4 pl-4">
                  <p tw="text-white text-base font-bold">
                    Set your own wash schedule.
                  </p>
                  <div tw="w-6 h-2 bg-primary"></div>
                  <p tw="text-white text-sm pt-4">
                    Choose a service, pick a plan, and then set your own day and
                    time preferences to receive the service.
                  </p>
                </div>
                <div tw="lg:py-6 py-4 pl-4">
                  <p tw="text-white text-base font-bold">
                    Partner arrives at your doorstep.
                  </p>
                  <div tw="w-6 h-2 bg-primary"></div>
                  <p tw="text-white text-sm pt-4">
                    As per your schedule to perform the 6-step car wash process
                    on your car, 12 times a month.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div tw="container mx-auto -mx-2">
        <div tw="grid grid-cols-2 gap-4">
          <div>
            <img src={glintclock} alt="process points" />
          </div>
          <div tw="flex flex-col justify-end lg:my-20">
            <p tw="text-gray-400 text-sm">6 STAGES</p>
            <p tw="text-white lg:text-3xl text-xl font-extrabold">
              Glint's car
            </p>
            <p tw="text-white lg:text-3xl text-xl font-extrabold">
              wash process
            </p>
            <p tw="text-white text-sm">Time: 15-20 minutes</p>
          </div>
        </div>
      </div>
      <div tw="container mx-auto">
        <div tw="grid lg:grid-cols-2 gap-4 mb-4">
          <div></div>
          <div tw="flex lg:justify-start justify-center mt-4 px-4">
            <div tw="lg:contents hidden">
              <img src={processpoints} alt="process points" width="30px" />
            </div>
            <div tw="flex flex-col xl:w-3/5 lg:w-4/5 md:w-1/2 w-full">
              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Inspect</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  The car is inspected and images of the car are taken before
                  starting the cleaning process.
                </p>
              </div>

              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Dusting</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  The car will be dusted using a duster to remove the dust
                  particles from the body.
                </p>
              </div>

              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Spraying</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  Car wash shampoo mixed with water will be sprayed over the
                  exterior of the car using a manual pressure pump.
                </p>
              </div>

              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Wiping</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  The froth will be wiped with a wet microfibre cloth followed
                  by a dry one to avoid water marks.
                </p>
              </div>

              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Windshield</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  Glass cleaner will be sprayed on the windshield/windows
                  glasses and will be wiped clean using a separate microfiber
                  cloth.
                </p>
              </div>
              <div tw="flex flex-col justify-center py-5 pl-4">
                <p tw="text-white text-base font-bold">Wash complete</p>
                <div tw="w-6 h-2 bg-primary"></div>
                <p tw="text-white text-sm pt-4">
                  Images are taken post the cleaning process and you will be
                  sent an automatic update message with an option to view the
                  wash images.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div tw="bg-white">
        <div tw="container mx-auto py-12 flex flex-col">
          <div tw="w-max self-center">
            <h1 tw="text-gray-600 md:text-7xl sm:text-5xl text-3xl font-black">
              spend a dime,
            </h1>
            <h1 tw="text-primary md:text-7xl sm:text-5xl text-3xl font-black ml-24 pb-4">
              always shine.
            </h1>
            <Link to="/about" tw="text-gray-600 font-semibold hover:text-gray-600">
              Learn more about <span tw="text-primary font-black">glint.</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessSection;
